import { Base } from './base.model';

export class SiteReviewNote extends Base {
  public note?: string;
  public type?: string;
  public siteId?: number;
}
